import { render, staticRenderFns } from "./SvgSectionComponent.vue?vue&type=template&id=5a6d7fc7"
import script from "./SvgSectionComponent.vue?vue&type=script&lang=js"
export * from "./SvgSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports